// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {get, omit} from 'lodash';

// Redux Actions
import {updatePriority, updatePriorityOnDrag} from '../actions/display-path-actions';
import servicesFormConfig from '../../config/services-form-config';

const withDisplayPath = (WrappedComponent, formName) => {
    class WithDisplayPath extends Component {
        getProps() {
            const {servicesSearchData} = this.props;
            return {
                ...omit(this.props, ['servicesSearchData']),
                searchValues: get(servicesSearchData, 'searchData.content.0', {}),
            };
        }

        render() {
            return <WrappedComponent {...this.getProps()} />;
        }
    }

    WithDisplayPath.propTypes = {
        formData: PropTypes.object,
        searchValues: PropTypes.object,
        servicesSearchData: PropTypes.object,
    };

    WithDisplayPath.displayName = `WithDisplayPath(${getDisplayName(WrappedComponent)})`;

    const mapStateToProps = (state) => ({
        formData: get(state.formData, [formName], {}),
        servicesSearchData: get(
            state.servicesSearchData,
            [get(servicesFormConfig, [formName, 'providerServiceDataKey'])],
            {}
        ),
    });

    const mapDispatchToProps = {
        updatePriority,
        updatePriorityOnDrag,
    };

    return connect(mapStateToProps, mapDispatchToProps)(WithDisplayPath);
};

function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

export default withDisplayPath;
